/**
 * External dependencies.
 */
import React from "react";
import type { GetStaticProps, NextPage } from "next";

/**
 * Internal dependencies.
 */
import { fetchAPI, getLocale, getLocalizationData, handleBaseLocales, loadTranslation } from "utils";
import BlogLogic from "components/blog-logic/blog-logic";

interface BlogProps {
  data: any;
  articles: any;
  articleTags: any;
  locale: string;
  locales: any;
}

const Blog: NextPage<BlogProps> = (prop) => (
  <BlogLogic
    hreflangs={prop.locales}
    prop={prop}
  />
);

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translation = await loadTranslation(
    ctx.locale!,
    process.env.NODE_ENV === "production"
  );
  const locale = getLocale(ctx.locale);

  const blog = fetchAPI("/blog", {
    populate: {
      SEO: {
        populate: "*",
      },
      localizations: {
        populate: "*",
      },
    },
    locale,
  });

  const articles = fetchAPI("/articles", {
    populate: "*",
    pagination: {
      page: 1,
      pageSize: 18,
    },
    locale,
  });

  const articleTags = fetchAPI("/article-tags", {
    populate: "*",
    locale,
  });

  const responses = await Promise.all([blog, articleTags, articles]);

  return {
    props: {
      translation,
      data: responses[0],
      articleTags: responses[1],
      articles: responses[2],
      locale: ctx.locale,
      locales: handleBaseLocales(ctx.locales),
      localizationData: getLocalizationData(responses[0]?.data, 'blog'),
    },
    revalidate: 10,
  };
};

export default Blog;
